<div class="score">
  <!-- Contenido -->
  <div class="content">
    <div class="content__title">
      <p>Puntaje</p>
      <qr-button
        [config]="this.buttonAdd"
        [isDisabled]="this.evaluationList.length >= 10"
        (click)="onAdd()"
      ></qr-button>
    </div>
    <div class="content__info">
      <p>
        El proceso de reclutamiento permite definir entre 1 y 10 parámetros, que
        se utilizarán para asignar puntajes a los candidatos.
      </p>
    </div>
    <div class="content__wrapper" *ngIf="!this.loading; else loader">
      <ng-container *ngFor="let evaluation of this.evaluationList">
        <div class="item">
          <qr-chip
            class="chip"
            [config]="chipEvaluation"
            [value]="evaluation.evaluation"
          ></qr-chip>
          <div class="item__actions">
            <qr-button
              [config]="buttonEdit"
              (click)="onEdit(evaluation)"
              matTooltip="Editar"
            ></qr-button>
            <qr-button
              [config]="buttonDelete"
              (click)="onDelete(evaluation)"
              matTooltip="Borrar"
            ></qr-button>
          </div></div
      ></ng-container>
    </div>
    <ng-template #loader>
      <div class="content__wrapper">
        <ng-container *ngFor="let load of [0, 1, 2, 3, 4, 5, 6]">
          <div class="item">
            <qr-skeleton-loader class="sk-loader"></qr-skeleton-loader>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
  <!-- Contenido -->
</div>

<!-- Dialogo acciones -->
<ng-container *ngIf="this.isOverlayVisible">
  <qr-overlay [(isOverlayVisible)]="isOverlayVisible" [config]="overlay">
    <div class="dialog">
      <qr-overlay-topbar (close)="isOverlayVisible = false">{{
        this.dialogTitle
      }}</qr-overlay-topbar>
      <div
        class="dialog__container"
        [ngSwitch]="true"
        [ngClass]="{
          add: this.dialogAction == this.ACTION_ADD,
          edit: this.dialogAction == this.ACTION_EDIT,
          delete: this.dialogAction == this.ACTION_DELETE
        }"
      >
        <ng-container *ngSwitchCase="this.dialogAction == this.ACTION_ADD">
          <p>Nombre</p>
          <div class="dialog__input">
            <qr-input
              [config]="inputAdd"
              (keydown)="onKeyDown($event)"
              [value]="this.parameterName"
              (valueChange)="changeInputAdd($event)"
            ></qr-input>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="this.dialogAction == this.ACTION_EDIT">
          <p>Nombre</p>
          <div class="dialog__input">
            <qr-input
              [config]="inputAdd"
              [value]="this.parameterName"
              (valueChange)="changeInputAdd($event)"
              (keydown)="onKeyDown($event)"
            ></qr-input>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="this.dialogAction == this.ACTION_DELETE">
          <p>
            ¿Está seguro que desea eliminar el parámetro de puntaje
            <strong>{{ this.parameterName }}</strong
            >? esta acción será irreversible.
          </p>
        </ng-container>
      </div>
      <div class="dialog__actions">
        <qr-button
          [config]="buttonDialogCancel"
          (click)="this.isOverlayVisible = false"
        ></qr-button>
        <qr-button
          [config]="
            this.dialogAction != this.ACTION_DELETE
              ? buttonDialogSave
              : buttonDialogDelete
          "
          [isDisabled]="!this.parameterName"
          (click)="onSave()"
        ></qr-button>
      </div>
    </div>
  </qr-overlay>
</ng-container>
